import { getImageCrop } from "../helpers/ImageCrop";
import { News } from "../models/News";
import { NewsUmbraco } from "../models/Umbraco/News.umb";
import { fetchUmbracoContent } from "./utils";

export const NewsApi = {
  async getNews(
    take?: number,
    skip?: number
  ): Promise<{
    total: number;
    items: Record<string, News>[];
  }> {
    const data = await fetchUmbracoContent<NewsUmbraco>("children:nyheder", take, skip);
    
    const items = await Promise.all(data.items
      .filter(item => !item.properties.hideInCollections)
      .map(async (item) => {
        const imageCrop = await getImageCrop(item);
        const publishedDate = new Date(item.properties.contentDetailsPublishedDate);

        const returnObject: News = {
          iID: item.id,
          title: item.name,
          teaser: item.properties.contentSettingsTeaser,
          pictures: { threeTwo: imageCrop },
          link: item.route.path,
          publishedDate,
          formatTypes: [],
          themeTypes: [],
          sectorTypes: [],
        };

        if (item.contentType === "newsPageV2024") {
          returnObject.themeTypes = item.properties.newsThemeTypes?.map(c => c.name) ?? [];
          returnObject.formatTypes = item.properties.newsFormatTypes?.map(c => c.name) ?? [];
          returnObject.sectorTypes = item.properties.contentDetailsTagsSector ?? [];
        } else {
          returnObject.themeTypes = item.properties.contentDetailsTagsTheme ?? [];
          returnObject.sectorTypes = item.properties.contentDetailsTagsSector ?? [];
          returnObject.formatTypes = item.properties.articleFormatTypes ?? ["Artikel"];
        }

        return returnObject;
      }));

    return { items: items.sort((a, b) => new Date(b.publishedDate).getTime() - new Date(a.publishedDate).getTime()), total: data.total };
  },
};
